<template>
  <div class="staking-fund">
    <div class="staking-fund-header" :style="{height: headerHeight+'px'}">
      <div class="staking-fund-header-msg">
        <h2>$10,000 Staking Fund</h2>
        <div>
          <p>The fund is established to reward the investors who stake their tokens to PoS Node</p> committed to developing <span @click="openWindow('https://www.posnode.com/')">PoS Node</span> to world's largest staking service platform.
        </div>
      </div>
    </div>
    <div class="staking-fund-card-box">
      <h3>Fund Spending</h3>
      <div class="staking-fund-card-bg">
        <div class="staking-fund-card">
          <div class="staking-fund-card-top">
            <div class="staking-fund-card-top-time">The fund will be all sent out until 2023 May 16th</div>
            <span class="staking-fund-card-amount">${{10000 - unspending}}</span>
            <div class="staking-fund-card-progress">
              <p :style="{width: progressWidth +'%'}"><b></b></p>
            </div>
            <div class="staking-fund-progress-total">
              <p>
                <span class="staking-fund-progress-total-number">Total <b>$10,000</b></span>
                <span>Unspending <b>$9,497</b></span>
              </p>
              <button @click="fundShow = true">Spending history</button>
            </div>
          </div>
          <div class="staking-fund-card-bottom">
            <img src="../../static/images/fund/trophy.svg" alt="">
            <ul>
              <li class="staking-fund-card-bottom-link">
                <div class="staking-fund-card-bottom-running"><span><b>2022.6.22 ~ </b>2022.9.22</span></div>
                <div>
                  <p>Status: Cardano summer staking rewards is running. Total prize 3000 ADA. <router-link to="/cardano-summer-staking-rewards"><i class="fa fa-angle-right" aria-hidden="true"></i></router-link></p>
                </div>
              </li>
              <!-- <li class="staking-fund-card-bottom-running">
                <span><b>2022.7.28 ~ 2022.8.12</b></span>
                <p><i></i> Purchase $570 (1000) ADA.</p>
              </li>
              <li class="staking-fund-card-bottom-link" style="margin-bottom: 0;">
                <div>
                  <p>Status: Solana staking rewards is running. Total prize 7.5 SOL. <router-link to="/solana-staking-rewards-01"><i class="fa fa-angle-right" aria-hidden="true"></i></router-link></p>
                </div>
              </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="staking-fund-roadmap">
      <h3>PoS Node Roadmap</h3>
      <ul>
        <li class="staking-fund-roadmap-in">
          <p>Add more Proof of Stake networks, aim to cover 30+ popular assets for staking.</p>
          <div><b></b></div>
        </li>
        <li class="staking-fund-roadmap-gray">
          <p>Build dashboard for delegators to track and manage your detailed staking income.</p>
          <div><b></b></div>
        </li>
        <li class="staking-fund-roadmap-gray">
          <p>Provide a whole picuture and deep analysis of each Proof of Stake network.</p>
          <div><b></b></div>
        </li>
      </ul>
    </div>

    <div class="content-faq">
      <h3>FAQ</h3>
      <ul>
        <li>
          <div class="content-faq-title">
            <p>Why should I stake?</p>
            <img src="../../static/images/svg/expand.svg" alt="">
          </div>
          <div id="collapse1" class="content-faq-content collapse">
            <p>Staking is an effective way to grow your crypto while help to secure the Proof of Stake networks.</p>
          </div>
        </li>

        <li>
          <div class="content-faq-title">
            <p>What happened after I stake my token?</p>
            <img src="../../static/images/svg/expand.svg" alt="">
          </div>
          <div id="collapse1" class="content-faq-content collapse">
            <p>You are not giving away ownership by delegating. You can unstake it anytime, and move your token round after the lock up period. As a validator, PoS Node will never have the ability to move your crypto.</p>
          </div>
        </li>

        <li>
          <div class="content-faq-title">
            <p>Why PoS Node provide staking service?</p>
            <img src="../../static/images/svg/expand.svg" alt="">
          </div>
          <div id="collapse1" class="content-faq-content collapse">
            <div class="content-faq-content-item"><p>PoS Node users can earn free cryptos by view websites and doing offers. The earned crypto amount is relatively small.<br>Staking services provide an effective way to release the earning potential for users.</p></div>
            <div class="content-faq-content-item"><p>In addition, Proof of Staking blockchains are environment friendly and a great invonation compared to triditional banking system.<br>We believe that the future of the earth must not be at the expense of the environment. This is why we are continuously building infrastures for Proof of Stake blockchains.</p></div>
          </div>
        </li>

        <li>
          <div class="content-faq-title">
            <p>Why Staking Fund is established?</p>
            <img src="../../static/images/svg/expand.svg" alt="">
          </div>
          <div class="content-faq-content collapse">
            <div class="content-faq-content-item"><p>The fund is established to attract investors to delegate the tokens to PoS Node, and make compensation to investors for staking rewards waiting period.</p></div>
            <div class="content-faq-content-item"><p>For example, as a Cardano validator, it needs about 1 million ADA delegation to produce a block each epoch.While for PoS Node, we just starts our service, there is no enough ADA delegation. It will take months to produce a block, then to share the staking rewards to our delegators.<br>Then the fund will be sent to the delegators during the staking reward waiting period.</p></div>
            <div class="content-faq-content-item"><p>Let's take Cosmos staking as another example, only the top 175 nodes with most ATOM delegation can be the active validator. While for PoS Node, we just starts our service, there is no enough ATOM delegation. When we are an inactive validator, your ATOM delegation will not earn you staking rewards, so the fund will be used to reward even we are not an active validator.</p></div>
            <div class="content-faq-content-item"><p>For Oasis Network staking, PoS Node is already an active validator, you can earn staking rewards already. We will be also glad to send you extra Rose to you, as a rewards for you to choose PoS Node as your staking service platform.</p></div>
            <div class="content-faq-content-item"><p>Basically we use this fund to build a win-win mode for both investors and PoS Node, and build a sustainalbe future together with you together!</p></div>
          </div>
        </li>
      </ul>
    </div>

    <div class="fund-model-box" v-if="fundShow">
      <div class="fund-model">
        <div class="fund-model-header">
          <span @click="fundShow = false">✕</span>
        </div>
        <h4>Spending history</h4>
        <div class="fund-model-scroll">
          <ul>
            <li>
              <span>2022.8.12</span>
              <p> 7.5 SOL ($338) is released in the Solana staking rewards campagin 01. <router-link to="/solana-staking-rewards-01"><i class="fa fa-angle-right" aria-hidden="true"></i></router-link></p>
            </li>
            <li>
              <span>2022.6.16</span>
              <p> 300 ADA ($165) is released in the Cardano staking rewards campagin 01. <router-link to="/cardano-rewards-01"><i class="fa fa-angle-right" aria-hidden="true"></i></router-link></p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default{
  data () {
    return {
      unspending: 9497,
      faqIndex: -1,
      fundShow: false
    }
  },
  computed: {
    progressWidth: function () {
      let num = (10000 - this.unspending) / 10000 * 100
      return num < 5 ? 5 : num
    }
  },
  created () {
    if ($(window).width() <= 700) {
      this.headerHeight = 400
    } else {
      this.headerHeight = $(window).height() - 90
    }
    $(window).resize(() => {
      if ($(window).width() <= 700) {
        this.headerHeight = 400
      } else {
        this.headerHeight = $(window).height() - 90
      }
    })
  },
  mounted () {
    let that = this
    $('.content-faq-title').on('click', function () {
      $(this).parent().siblings().find('.content-faq-content').slideUp(200).siblings().find('img').css({'transform': 'rotateZ(-90deg)'})
      if (that.faqIndex === $(this).parent().index()) {
        that.faqIndex = -1
        $(this).find('img').css({'transform': 'rotateZ(-90deg)'})
      } else {
        that.faqIndex = $(this).parent().index()
        $(this).find('img').css({'transform': 'rotateZ(0deg)'})
      }
      $(this).siblings().slideToggle(200)
      $('html,body').animate({scrollTop: $('body')[0].scrollHeight}, 400)
    })
    $('.content-calculator-coin-type-selected').on('click', function () {
      $(this).siblings().slideToggle(200)
    })
    $('.content-calculator-coin-type-choose').on('click', function () {
      $(this).slideUp(200)
    })
  },
  methods: {
    toUrl: function (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    openWindow: function (url) {
      window.open(url, '_blank')
    }
  },
  metaInfo () {
    return {
      title: '$10,000 Staking Fund',
      meta: [
        {
          name: 'description',
          content: `Developping PoS Node to world's largest staking service platform.`
        }
      ]
    }
  }
}
</script>

<style scoped>
html,body{
  height: auto !important;
}
.staking-fund-header{
  background: url('../../static/images/fund/staking_p1.png') center bottom;
  background-size: 100% auto;
  position: relative;
}
.staking-fund-header-msg{
  text-align: center;
  max-width: 1230px;
  width: 100%;
  padding: 0 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.staking-fund-header-msg h2{
  font-size: 86px;
  font-family: 'FRAHV';
  color: #FFFFFF;
}
.staking-fund-header-msg div{
  font-size: 26px;
  font-family: 'PingFangSC-Medium';
  color: #C0C0C0;
  text-shadow: 4px 4px 5px #131313;
  margin: 0;
  line-height: 50px;
}
.staking-fund-header-msg div p{
  margin: 0;
  font-size: 26px;
  font-family: 'PingFangSC-Medium';
  color: #C0C0C0;
}
.staking-fund-header-msg div span{
  border-bottom: 1px solid #2E8928;
  color: #2E8928;
  font-size: 26px;
  cursor: pointer;
}
.staking-fund-card-box{
  max-width: 1920px;
  margin: 0 auto;
  background: #FCF9F8;
  padding: 120px 0 165px 0;
}
.staking-fund-card-bg{
  background: url('../../static/images/fund/staking_p2.png') no-repeat center center;
  background-size: auto 620px;;
  padding: 0 20px;
}
.staking-fund-card{
  max-width: 1154px;
  height: 620px;
  margin: 0 auto;
  background: url('../../static/images/fund/staking_p2_bg.png') no-repeat center center;
  background-size: auto 100%;
  box-shadow: 14px 14px 21px 0px #E7D1CA, 0px 2px 3px 0px #FFCEB9;
  border-radius: 40px;
  overflow: hidden;
  position: relative;
}
.staking-fund-card-top{
  padding: 0px 48px 33px 48px;
}
.staking-fund-card-top-time{
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #BAF1B6;
  padding: 15px 0;
  margin-bottom: 30px;
  text-align: right;
}
.staking-fund-card-bottom{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #EAFAE9;
  padding: 20px 20px 20px 48px;
  display: flex;
}
.staking-fund-card-bottom img{
  width: 60px;
  height: 66px;
  margin-right: 40px;
}
.staking-fund-card-bottom ul{
  margin: 0;
}
.staking-fund-card-bottom ul li{
  margin-bottom: 20px;
}
.staking-fund-card-bottom ul li:last-child{
  margin-bottom: 0;
}
.staking-fund-card-bottom-running {
  margin-bottom: 10px;
}
.staking-fund-card-bottom-running p{
  margin: 0 0 0 26px;
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #626262;
  display: flex;
  align-items: center;
}
.staking-fund-card-bottom-running p i{
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #626262;
  border-radius: 50%;
  margin-right: 6px;
}
.staking-fund-card-bottom-link p{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #0E2F0C;
  margin: 0;
}
.staking-fund-card-bottom-link p a{
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #CAEDC8;
  border-radius: 50%;
  color: #2FA427;
  margin-left: 10px;
  text-align: center;
  line-height: 20px;
}
.staking-fund-card-bottom-link p span{
  display: inline-block;
  width: 26px;
  height: 26px;
  background: #CAEDC8;
  border-radius: 50%;
  color: #2FA427;
  line-height: 26px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  margin-left: 20px;
}
.staking-fund-card-bottom-running{
  display: flex;
  align-items: center;
}
.staking-fund-card-bottom-running span{
  font-size: 18px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #367333;
}
.staking-fund-card-bottom-running span b{
  font-size: 18px;
  padding: 0 10px;
  background: #CAEDC8;
  border-radius: 17px;
  font-weight: 400;
}
.staking-fund-card-amount{
  font-size: 56px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #FFFFFF;
  text-shadow: 2px 2px 8px #21751C;
  margin-left: 33px;
}
.staking-fund-card-progress{
  height: 100px;
  background: #195915;
  box-shadow: 0px 2px 16px 0px #11420E;
  border-radius: 50px;
  margin-top: 56px;
}
.staking-fund-card-progress p{
  position: relative;
  height: 100px;
  background: #67DA60;
  border-radius: 50px 0 0 50px;
}
.staking-fund-card-progress b{
  position: absolute;
  top: -50px;
  right: -10px;
  width: 20px;
  height: 40px;
  background: url('../../static/images/fund/staking_p4.svg') no-repeat center center;
  background-size: 100% 100%;
}
.staking-fund-progress-total{
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1058px;
  width: 100%;
  margin-top: 100px;
}
.staking-fund-progress-total-number{
  margin-right: 124px;
}
.staking-fund-progress-total p {
  margin: 0;
}
.staking-fund-progress-total p span{
  width: 185px;
  height: 27px;
  font-size: 26px;
  font-family: 'PingFangSC-Medium';
  color: #FFFFFF;
}
.staking-fund-progress-total p span b{
  font-family: 'FRAHV';
}
.staking-fund-progress-total button{
  border: 1px solid #FFFFFF;
  outline: 0;
  padding: 8px 20px;
  font-size: 24px;
  font-family: 'PingFangSC-Medium';
  font-weight: 400;
  border-radius: 30px;
  color: #FFFFFF;
  background: transparent;
  cursor: pointer;
}
.staking-fund-roadmap{
  background: #232121;
  padding: 124px 100px 160px 100px;
}
.staking-fund-roadmap h3{
  font-size: 50px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #FFFFFF;
  margin: 0 0 127px 0;
  text-align: center;
}
.staking-fund-roadmap ul{
  display: flex;
}
.staking-fund-roadmap ul li{
  flex: 1;
  margin: 0 10px;
  text-align: center;
}
.staking-fund-roadmap ul li span{
  font-size: 26px;
  font-family: 'PingFangSC-Medium';
  font-weight: 800;
  color: #2FA427;
}
.staking-fund-roadmap ul li div{
  margin: 22px 0 53px 0;
  position: relative;
  height: 10px;
  background: #2FA427;
}
.staking-fund-roadmap ul li p{
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #FFFFFF;
  margin: 0;
}
.staking-fund-roadmap ul li.staking-fund-roadmap-have b{
  position: absolute;
  right: -4px;
  top: -30px;
  width: 13px;
  height: 30px;
  background: url('../../static/images/fund/staking_p3.svg') no-repeat center center;
  background-size: 100% 100%;
}
.staking-fund-roadmap ul li.staking-fund-roadmap-in div{
  background: url('../../static/images/fund/staking_p4.png') no-repeat center center;
  background-size: 100% 100%;
}
.staking-fund-roadmap ul li.staking-fund-roadmap-gray span{
  font-size: 26px;
  font-family: 'PingFangSC-Medium';
  font-weight: 800;
  color: #9E5230;
}
.staking-fund-roadmap ul li.staking-fund-roadmap-gray div{
  background: #484545;
}
.staking-fund-roadmap ul li.staking-fund-roadmap-gray p{
  color: #848484;
}

.content-faq{
  max-width: 1380px;
  background: #FFFFFF;
  overflow: hidden;
  margin: 113px auto 30px auto;
  padding: 0 20px;
}
.content-faq h3, .staking-fund-card-box h3{
  margin-bottom: 76px;
  font-size: 50px;
  font-family: 'FRAHV';
  font-weight: 400;
  color: #333333;
  text-align: center;
}
.content-faq ul li{
  border-radius: 35px;
  background: #F5F5F5;
  margin-bottom: 10px;
  overflow: hidden;
}
.content-faq ul li a{
  text-decoration: none;
  color: #FF7032;
}
.content-faq .content-faq-title{
  display: flex;
  justify-content: space-between;
  padding: 25px 30px;
  cursor: pointer;
  font-size: 20px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #333333;
}
.content-faq .content-faq-title p{
  font-family: 'PingFangSC-Medium';
  margin: 0;
  font-weight: 400;
  color: #333333;
  font-size: 20px;
}

.content-faq .content-faq-title img{
  width: 14px;
  height: auto;
  -moz-transform: rotateZ(-90deg);
  -ms-transform: rotateZ(-90deg);
  -webkit-transform: rotateZ(-90deg);
  transform: rotateZ(-90deg);
  -moz-transition: transform 500ms ease 0s;
  -ms-transition: transform 500ms ease 0s;
  -webkit-transition: transform 500ms ease 0s;
  transition: transform 500ms ease 0s;
}
.content-faq .content-faq-content{
  border-top: 1px solid #cccccc;
  padding: 25px 30px 15px 30px;
  font-size: 16px;
  font-family: 'PingFangSC-Medium';
  font-weight: 400;
  color: #303030;
}
.content-faq .content-faq-content P{
  margin-bottom: 10px;
  text-align: left;
  font-size: 16px;
  font-family: 'PingFangSC-Medium';
  color: #333333;
}
.content-faq-content-item{
  display: flex;
  margin-bottom: 10px;
}
.content-faq-content-item p{
  margin: 0;
}
.fund-model-box{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}
.fund-model{
  max-width: 898px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 40px;
  padding: 30px 0 30px 40px;
}
.fund-model-header{
  text-align: right;
  padding-right: 40px;
}
.fund-model-header span{
  display: inline-block;
  width: 27px;
  height: 27px;
  border: 1px solid #666666;
  border-radius: 50%;
  text-align: center;
  line-height: 27px;
  cursor: pointer;
}
.fund-model h4{
  font-family: 'FRAHV';
  color: #000000;
  font-size: 26px;
}
.fund-model-scroll{
  height: 460px;
  overflow: hidden;
  overflow-y: auto
}
.fund-model-scroll::-webkit-scrollbar{
  width:8px;
  height:8px;
  background-color: #ECECEC;
}
.fund-model-scroll::-webkit-scrollbar-track{
  background: #ffffff;
}
.fund-model-scroll::-webkit-scrollbar-thumb{
  background: #ECECEC;
  border-radius:4px;
}
.fund-model-scroll::-webkit-scrollbar-thumb:hover{
  background: #ECECEC;
}
.fund-model-scroll::-webkit-scrollbar-corner{
  background: #ECECEC;
}
.fund-model-scroll ul {
  margin: 0;
  padding-right: 40px;
}
.fund-model-scroll ul li{
  padding: 15px 0 15px 46px;
  background: #F7F7F7;
  border-radius: 30px;
  display: flex;
  align-items: center;
  margin: 10px 0;
}
.fund-model-scroll ul li p{
  flex: 1;
  margin: 0;
  font-size: 16px;
  font-family: 'PingFangSC-Medium';
  color: #545454;
  text-align: left;
}
.fund-model-scroll ul li p b{
  color: #333333;
  font-family: 'FRAHV';
}
.fund-model-scroll ul li span{
  font-size: 16px;
  font-family: 'PingFangSC-Medium';
  font-weight: 500;
  color: #545454;
  width: 100px;
  margin-right: 68px;
}
@media (max-width: 1120px) {
  .staking-fund-header-msg h2{
    font-size: 50px;
  }
  .staking-fund-header-msg div{
    font-size: 18px;
  }
  .staking-fund-header-msg div p{
    font-size: 18px;
  }
  .staking-fund-header-msg div span{
    font-size: 18px;
  }
  .staking-fund-roadmap{
    padding: 100px 60px 120px 60px;
  }
  .staking-fund-roadmap h3{
    margin-bottom: 80px;
    font-size: 30px;
  }
  .staking-fund-roadmap ul li span{
    font-size: 20px !important;
  }
  .staking-fund-roadmap ul li p{
    font-size: 16px !important;
  }
  .content-faq {
    margin-top: 50px;
  }
  .content-faq h3, .staking-fund-card-box h3{
    font-size: 30px;
    margin-bottom: 30px;
  }
  .content-faq .content-faq-title{
    font-size: 18px;
    padding: 15px 20px
  }
  .content-faq .content-faq-content{
    font-size: 16px;
    padding: 15px 20px
  }
  .staking-fund-card-box{
    padding: 100px 0;
  }
  .staking-fund-card-bg{
    background-size: auto 460px;
  }
  .staking-fund-card{
    max-width: 800px;
    height: 460px;
    border-radius: 25px;
  }
  .staking-fund-card-top{
    padding: 0px 20px;
  }
  .staking-fund-card-top-time{
    font-size: 18px;
    margin: 0;
  }
  .staking-fund-card-amount{
    font-size: 30px;
  }
  .staking-fund-card-progress{
    height: 60px;
    border-radius: 30px;
    box-shadow: 0px 2px 10px 0px #6B3E27;
  }
  .staking-fund-card-progress b{
    position: absolute;
    top: -30px;
    right: -5px;
    width: 10px;
    height: 20px;
  }
  .staking-fund-card-progress p{
    height: 60px;
    border-radius: 30px 0 0 30px;
  }
  .staking-fund-progress-total{
    margin-top: 30px;
  }
  .staking-fund-progress-total p span{
    font-size: 20px;
  }
  .staking-fund-progress-total-number{
    margin-right: 50px;
  }
  .staking-fund-progress-total button{
    padding: 5px 8px;
    outline: 0;
    border-radius: 30px;
    font-size: 20px;
    font-family: 'PingFangSC-Medium';
  }
  .staking-fund-card-bottom{
    padding: 10px 10px 10px 20px;
  }
  .staking-fund-card-bottom img{
    margin-right: 20px;
  }
  .staking-fund-card-bottom ul li{
    margin-bottom: 15px;
  }
  .staking-fund-card-bottom-running{
    display: block;
  }
  .staking-fund-card-bottom-running p{
    margin: 0;
    font-size: 14px;
    text-align: left;
  }
  .staking-fund-card-bottom-running span,.staking-fund-card-bottom-running span b{
    font-size: 14px;
  }
  .staking-fund-card-bottom-link{
    margin-top: 5px;
  }
  .staking-fund-card-bottom-link p{
    font-size: 16px;
    text-align: left;
  }
  .staking-fund-card-bottom-link p span{
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin-left: 10px;
  }
  .fund-model h4{
    font-size: 20px;
  }
  .fund-model-scroll ul li{
    padding: 10px 15px;
  }
  .fund-model-scroll ul li span{
    margin-right: 5%;
    font-size: 14px;
  }
  .fund-model-scroll ul li p{
     font-size: 14px;
  }
}
@media (max-width: 780px) {

.staking-fund-header-msg div{
  line-height: 30px;
}
.staking-fund-header-msg div p{
  display: inline;
}
  .staking-fund-header-msg h2{
    font-size: 30px;
  }
  .staking-fund-roadmap{
    padding: 30px 20px;
  }
  .staking-fund-roadmap h3{
    margin-bottom: 30px;
  }
  .staking-fund-roadmap ul li.staking-fund-roadmap-in div{
    background-size: auto 100%;
  }
  .staking-fund-roadmap ul li.staking-fund-roadmap-have b{
    position: absolute;
    right: -2px;
    top: -20px;
    width: 8px;
    height: 20px;
  }
  .staking-fund-card-box{
    padding: 50px 0;
  }
  .staking-fund-card{
    height: 400px;
  }
  .staking-fund-card-amount{
    margin-left: 10px;
  }
  .staking-fund-card-progress{
    height: 30px;
    border-radius: 15px;
    margin-top: 40px;
  }
  .staking-fund-card-progress p{
    height: 30px;
    border-radius: 15px 0 0 15px;
  }
  .staking-fund-progress-total p span{
    font-size: 16px;
  }
  .staking-fund-progress-total button{
    font-size: 16px;
  }
  .fund-model-scroll ul li{
    display: block;
  }
  .fund-model-scroll ul li p{
    text-align: left;
  }
  .fund-model{
    padding: 20px 0 20px 20px;
  }
  .fund-model-scroll ul{
    padding-right: 20px;
  }
  .fund-model-header{
    padding-right: 20px;
  }
}
@media (max-width: 700px) {
  .staking-fund-roadmap ul{
    display: block;
  }
  .staking-fund-roadmap ul li{
    margin-bottom: 100px;
  }
  .staking-fund-roadmap ul li div{
    max-width: 324px;
    width: 100%;
    margin: 20px auto;
  }
  .staking-fund-card{
    height: 430px;
  }
}
@media (max-width: 600px) {
  .staking-fund-progress-total p span{
    margin-right: 10px;
  }
  .staking-fund-card{
    height: auto;
  }
  .staking-fund-card-bottom{
    position: static;
  }
  .staking-fund-card{
    border-radius: 10px;
  }
  .staking-fund-progress-total{
    margin: 15px 0;
    display: block;
  }
 .staking-fund-progress-total button{
   display: block;
   margin: 20px auto;
 }
 .staking-fund-card-top-time{
   font-size: 14px;
 }
}
</style>



// WEBPACK FOOTER //
// src/pages/staking_fund.vue